import { Sentry } from '@/plugins/sentry';

// Must match the key written by the inline watchdog in public/index.html.
export const BOOT_RECOVERY_KEY = 'aloha.boot-recovery';

/**
 * Second half of the boot-recovery pair; the inline <script> in public/index.html is the first.
 * An index.html served past its deploy requests bundle hashes the server no longer has: they
 * 404, no application code runs, and the white page cannot report itself — which is why this
 * went undiagnosed through two attempted fixes. The watchdog reloads once and leaves a marker;
 * reporting it here is the only signal we get.
 *
 * Both halves are workarounds for assets not outliving their deploy. Serve /js and /css from
 * append-only storage and this file, the watchdog, and window.__ALOHA_BOOTED__ can all go.
 */
export function reportBootRecovery() {
  try {
    if (sessionStorage.getItem(BOOT_RECOVERY_KEY) !== '1') return;
    sessionStorage.removeItem(BOOT_RECOVERY_KEY);
  } catch (e) {
    return; // storage blocked; the watchdog never armed either
  }

  // Not phrased as "stale index.html": the flag is set after main.js's imports evaluate, so an
  // exception anywhere in that graph lands here too. Common cause, not the only one.
  Sentry.captureMessage('Boot recovery: app did not start, reloaded once', {
    url: window.location.href,
    referrer: document.referrer,
  });
}
